// Razão social das solicitações da tela Automações (TXM-655).
//
// A API grava em automacao_solicitacao.razao_social o nome vindo da api-empresas e, quando essa busca
// não dá certo, grava o próprio CNPJ (best-effort: nunca bloqueia a solicitação). Resultado: linhas em
// que a coluna "Razão Social" mostra só os 14 dígitos. Aqui a tela troca esse CNPJ pelo nome do Cadastro
// de Empresas na hora de EXIBIR, o que corrige também as linhas antigas sem mexer no banco.

const soDigitos = (v) => (v || "").replace(/\D/g, "");

/** true quando o "nome" gravado é só o CNPJ (o fallback da API), ou seja, não há nome de verdade. */
export function razaoSocialEhSoCnpj(solicitacao) {
  const cnpj = soDigitos(solicitacao?.cnpj);
  const razao = String(solicitacao?.razao_social ?? "");
  return cnpj.length > 0 && /^[\d.\-/\s]+$/.test(razao) && soDigitos(razao) === cnpj;
}

/** CNPJs (só dígitos, sem repetir) das linhas que estão sem nome: o que a tela precisa resolver. */
export function cnpjsSemRazaoSocial(solicitacoes) {
  if (!Array.isArray(solicitacoes)) return [];
  return [...new Set(solicitacoes.filter(razaoSocialEhSoCnpj).map((s) => soDigitos(s.cnpj)))];
}

/**
 * Devolve as solicitações com o CNPJ-no-lugar-do-nome trocado pela razão social do cadastro.
 * Só toca em quem está sem nome; sem nada para trocar devolve a MESMA lista (referência), para não
 * provocar re-render à toa.
 * @param {object[]} solicitacoes
 * @param {Map<string,string>|null} nomesPorCnpj CNPJ só com dígitos -> razão social
 */
export function aplicarRazoesSociais(solicitacoes, nomesPorCnpj) {
  if (!nomesPorCnpj || nomesPorCnpj.size === 0) return solicitacoes;
  let mudou = false;
  const resultado = solicitacoes.map((s) => {
    if (!razaoSocialEhSoCnpj(s)) return s;
    const nome = nomesPorCnpj.get(soDigitos(s.cnpj));
    if (!nome) return s;
    mudou = true;
    return { ...s, razao_social: nome };
  });
  return mudou ? resultado : solicitacoes;
}
